import React, { useEffect, useState } from "react";
import { getMyAttendances } from "../../utils/helper";
import Loader from "../../utils/Loader";

export default function Notifications() {
    const [notifs, setNotifs] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getMyAttendances()
            .then((res) => { 
                if(res.data.success){
                    setNotifs(res.data.data);  
                }
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            })
            .catch((err) => { 
                console.log(err.response)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
    }, []);

    return (
        <>
            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">My Notifications</div>
                        </div>
                        <div className="card-body">
                        {(!loading && notifs && notifs) ?  <>
                            <div className="employee-noti-content">
                                {notifs && notifs.length > 0 ? 
                                    <ul className="employee-notification-list">
                                        {notifs && notifs.map((notif, i) => (
                                        <div className="employee-notification-grid" key={i} style={{width:"100%", marginLeft: -20}} >
                                            <div className="employee-notification-icon">
                                                <span className="badge-soft-danger rounded-circle">{i + 1}</span>
                                            </div>
                                            <div className="employee-notification-content">
                                                <h6>{notif.location && notif.location} </h6>
                                                <ul className="nav">
                                                    <li>{notif.timeIn && notif.timeIn}</li>
                                                    <li>{notif.date && notif.date}</li>
                                                </ul>
                                            </div>
                                        </div>
                                        ))}
                                    </ul>
                                : null }
                            </div>
                            </>
                            : <Loader /> }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
